import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api';
const vipPath = `${url}/external/vipBirth`;

// 0. 確認VIP身份
export function postLoginVIP(data) {
    return post(`${url}/auth/vipBirthLogin`, data, { ...options, closeAlert: true });
}

// 1. init初始化交易
export function postInitVIP() {
    return post(`${vipPath}/initTransaction`);
}

// 取得資料
export function getInfoVIP() {
    return get(`${vipPath}/info`);
}
